export default "__VITE_ASSET__DEigu1xj__"